import script from "./SegurosCarrusel.vue?vue&type=script&setup=true&lang=js"
export * from "./SegurosCarrusel.vue?vue&type=script&setup=true&lang=js"

import "./SegurosCarrusel.vue?vue&type=style&index=0&id=700f438a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-700f438a"]])

export default __exports__